import { CategoryDtoGroupNameEnum, CategoryDtoNameEnum, type CategoryDTO } from "api";

const categories: CategoryDTO[] = [
  {
    id: 1,
    name: CategoryDtoNameEnum.BARBERS,
    groupName: CategoryDtoGroupNameEnum.BEAUTY,
  },
  {
    id: 2,
    name: CategoryDtoNameEnum.MASSAGE_THERAPISTS,
    groupName: CategoryDtoGroupNameEnum.HEALTH_AND_WELLNESS,
  },
  {
    id: 3,
    name: CategoryDtoNameEnum.PERSONAL_TRAINERS,
    groupName: CategoryDtoGroupNameEnum.HEALTH_AND_WELLNESS,
  },
  {
    id: 4,
    name: CategoryDtoNameEnum.NAIL_TECHNICIANS,
    groupName: CategoryDtoGroupNameEnum.BEAUTY,
  },
  {
    id: 5,
    name: CategoryDtoNameEnum.PHOTOGRAPHERS,
    groupName: CategoryDtoGroupNameEnum.EVENTS_AND_CREATIVE,
  },
  {
    id: 6,
    name: CategoryDtoNameEnum.LANGUAGE_TEACHERS,
    groupName: CategoryDtoGroupNameEnum.EDUCATION,
  },
];

export const useCategories = () => {
  return {
    loading: false,
    loaded: true,
    categories,
  };
};
